/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener
 * crm-screener
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface PccPendingPatient
 */
export interface PccPendingPatient {
    /**
     * 
     * @type {string}
     * @memberof PccPendingPatient
     */
    facId?: string;
    /**
     * 
     * @type {string}
     * @memberof PccPendingPatient
     */
    patientId?: string;
    /**
     * 
     * @type {string}
     * @memberof PccPendingPatient
     */
    status?: string;
}

/**
 * Check if a given object implements the PccPendingPatient interface.
 */
export function instanceOfPccPendingPatient(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function PccPendingPatientFromJSON(json: any): PccPendingPatient {
    return PccPendingPatientFromJSONTyped(json, false);
}

export function PccPendingPatientFromJSONTyped(json: any, ignoreDiscriminator: boolean): PccPendingPatient {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'facId': !exists(json, 'facId') ? undefined : json['facId'],
        'patientId': !exists(json, 'patientId') ? undefined : json['patientId'],
        'status': !exists(json, 'status') ? undefined : json['status'],
    };
}

export function PccPendingPatientToJSON(value?: PccPendingPatient | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'facId': value.facId,
        'patientId': value.patientId,
        'status': value.status,
    };
}

